import { createContext } from 'react';
const ReporteadorContext = createContext(); 

export default ReporteadorContext;